export default {
  POINT: 'point',
  LINE: 'line',
  POLYGON: 'polygon',
  TEXT: 'text',
  MODIFY: 'modify',
  DELETE: 'delete',
  COORDINATE: 'coordinate',
  BUFFERED_LINE: 'buffered_line',
  COPY: 'copy'
}
